// extracted by mini-css-extract-plugin
export default {"UPSLinkBody":"UPSLink_UPSLinkBody__suwxi","label":"UPSLink_label__-W6WT","UPSLinkContent":"UPSLink_UPSLinkContent__b5w+P","form":"UPSLink_form__Ba0Ip","logo":"UPSLink_logo__bkBKs"};